module.exports = __webpack_public_path__ + "static/media/green.780ab891.png";